import { Component, input, signal, inject, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-svg-icon',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (svgContent()) {
      <div [innerHTML]="svgContent()" [class]="iconClass()"></div>
    }
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      :host ::ng-deep svg {
        width: 100%;
        height: 100%;
        display: block;
      }
    `,
  ],
})
export class SvgIconComponent {
  private http = inject(HttpClient);
  private sanitizer = inject(DomSanitizer);

  src = input.required<string>();
  iconClass = input<string>('');

  svgContent = signal<SafeHtml>('');

  constructor() {
    effect(() => {
      const source = this.src();
      if (source) {
        this.loadSvg(source);
      }
    });
  }

  private loadSvg(path: string): void {
    const fullPath = path.startsWith('assets/')
      ? path
      : `assets/images/${path}`;

    this.http.get(fullPath, { responseType: 'text' }).subscribe({
      next: svg => {
        this.svgContent.set(this.sanitizer.bypassSecurityTrustHtml(svg));
      },
      error: error => {
        console.error(`Failed to load SVG: ${fullPath}`, error);
      },
    });
  }
}
